import * as React from "react";
import { OI } from "../onam/mark";
import { FEATURES } from "../onam/features";

type Props = React.SVGProps<SVGSVGElement> & { title?: string };

function BaseFilterIcon({ title, ...props }: Props) {
  return (
    <svg
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden={title ? undefined : true}
      role="img"
      width={18}
      height={18}
      {...props}
    >
      {title ? <title>{title}</title> : null}
      <path
        d="M3 2.25H15C15.1989 2.25 15.3897 2.32902 15.5303 2.46967C15.671 2.61032 15.75 2.80109 15.75 3V4.1895C15.75 4.3884 15.6709 4.57913 15.5303 4.71975L10.7198 9.53025C10.5791 9.67087 10.5 9.8616 10.5 10.0605V14.7892C10.5 14.9033 10.474 15.0158 10.424 15.1182C10.374 15.2207 10.3013 15.3104 10.2114 15.3805C10.1215 15.4506 10.0169 15.4994 9.90532 15.523C9.79378 15.5466 9.67834 15.5445 9.56775 15.5167L8.06775 15.1417C7.90557 15.1011 7.76161 15.0075 7.65874 14.8757C7.55588 14.7438 7.5 14.5814 7.5 14.4142V10.0605C7.49996 9.8616 7.42091 9.67087 7.28025 9.53025L2.46975 4.71975C2.32909 4.57913 2.25004 4.3884 2.25 4.1895V3C2.25 2.80109 2.32902 2.61032 2.46967 2.46967C2.61032 2.32902 2.80109 2.25 3 2.25Z"
        stroke="currentColor"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

/* With the ONAM skin (FEATURES.curationSkin) this draws ONAM's "filter" glyph instead (onam/mark.tsx). */
const FilterIconSkin = (props: any) =>
  FEATURES.curationSkin ? (
    <OI n="filter" size={props.size || 16} className={props.className} style={props.style} onClick={props.onClick} title={props.title} color={props.color}
      onMouseOver={props.onMouseOver} onMouseOut={props.onMouseOut} onMouseEnter={props.onMouseEnter} onMouseLeave={props.onMouseLeave} />
  ) : (
    <BaseFilterIcon {...props} />
  );
export default FilterIconSkin;
